module.exports = __webpack_public_path__ + "images/price_banner.0e11aca.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/price_banner.png
// module id = 641
// module chunks = 0